export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12064.11781162.jpg";